import React, { useEffect, useState } from 'react'
import Layout from '../components/Layout'
import { useDispatch } from 'react-redux';
import { hideLoading, showLoading } from '../redux store/loader';
import "../stylings/publicDisclosure.css"
import { Link } from 'react-router-dom';
import axios from 'axios';
const PublicDisclosure = () => {

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(showLoading());
    setTimeout(() => {
      dispatch(hideLoading())
    }, [1700])
  }, [])

  const [disclosure, setDisclosure] = useState([])

  const getPublicDisclosure = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_PUBLIC_DISCLOSURE_API)
      setDisclosure(response.data)
    } catch (error) {
      console.log(error)
    }
  }

  const filteredData = disclosure.filter(item => item.typeid === 2)

  useEffect(() => {
    getPublicDisclosure()
  }, [])

  return (
    <Layout>
      <div className="public-disclosure container">
        <div className="public-disclosure-header">
          <h3><span className="word-leader">mandatory public</span> disclosure</h3>
          <div className="seprator-line-wrapper">
            <span className="seprator-one"></span>
            <span className="seprator-two"></span>
          </div>
        </div>

        {/* GENERAL INFORMATION */}
        <div className="table-responsive mb-3">
          <h5 className='table-header'>A: GENERAL INFORMATION</h5>
          <table className="table">
            <tbody>
              <tr>
                <th>S.No</th>
                <th>INFORMATION</th>
                <th>DETAILS</th>
              </tr>
              <tr>
                <td>1</td>
                <td>NAME OF THE SCHOOL</td>
                <td>Way, Truth and Life Foundation School</td>
              </tr>
              <tr>
                <td>2</td>
                <td>AFFILIATION NO (IF APPLICABLE)</td>
                <td>1236547</td>
              </tr>
              <tr>
                <td>3</td>
                <td>SCHOOL CODE (IF APPLICABLE)</td>
                <td>25987</td>
              </tr>
              <tr>
                <td>4</td>
                <td>COMPLETE ADDRESS WITH PIN CODE</td>
                <td>H Block, Phase 6
                  Aya Nagar Extension
                  New Delhi - 110047</td>
              </tr>
              <tr>
                <td>5</td>
                <td>PRINCIPAL NAME & QUALIFIACTION</td>
                <td>XYZ MSc (Chemistry) B.Ed</td>
              </tr>
              <tr>
                <td>6</td>
                <td>SCHOOL EMAIL ID</td>
                <td>
                  <p>wtlfoundation91@gmail.com</p>
                </td>
              </tr>
              <tr>
                <td>7</td>
                <td>CONTACT DETAILS (LANDLINE/MOBILE)</td>
                <td>Mobile No. : +91-8595015369</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* DOCUMENT AND INFORMATION */}
        <div className="table-responsive">
          <h5 className='table-header'>B: DOCUMENT AND INFORMATION</h5>
          <table className="table">
            <tbody>
              <tr>
                <th>S.No</th>
                <th>DOCUMENTS/INFORMATION</th>
                <th>UPLOAD DOCUMENTS</th>
              </tr>
              {
                filteredData.map((item, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{item.title}</td>
                    <td>
                      <Link to={item.attachments[0]?.path} target='_blank'>Click Here To View</Link>
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>

      </div>
    </Layout>
  )
}

export default PublicDisclosure
